var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle73BError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 69",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44.5 1.6H10l-.725 7.251a2.5 2.5 0 0 0 2.487 2.75H34.5a2.5 2.5 0 0 1 2.5 2.5v48.638a2.5 2.5 0 0 0 2.835 2.477l7.164-.969L47 4.1a2.5 2.5 0 0 0-2.5-2.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M8 1.6a1 1 0 0 1 1-1h35.5A3.5 3.5 0 0 1 48 4.1v61.5a1 1 0 1 1-2 0V4.1a1.5 1.5 0 0 0-1.5-1.5H9a1 1 0 0 1-1-1Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M15 66.1v-49a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v49a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.274 54.393A2.5 2.5 0 0 0 1 56.883v5.434a2.5 2.5 0 0 0 2.274 2.49l6 .545A2.5 2.5 0 0 0 12 62.862v-6.524a2.5 2.5 0 0 0-2.726-2.49l-6 .545Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M2 56.339c0-.687.388-1.315 1.002-1.622l.445-.222a1 1 0 1 0-.894-1.79l-.446.224A3.813 3.813 0 0 0 0 56.338v6.523c0 1.444.816 2.764 2.107 3.41l.446.223a1 1 0 1 0 .894-1.79l-.445-.222A1.812 1.812 0 0 1 2 62.863v-6.524Z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.274 18.393A2.5 2.5 0 0 0 1 20.883v5.434a2.5 2.5 0 0 0 2.274 2.49l6 .545A2.5 2.5 0 0 0 12 26.862v-6.524a2.5 2.5 0 0 0-2.726-2.49l-6 .545Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M2 20.338c0-.686.388-1.314 1.002-1.62l.445-.223a1 1 0 1 0-.894-1.79l-.446.224A3.813 3.813 0 0 0 0 20.338v6.523c0 1.444.816 2.764 2.107 3.41l.446.223a1 1 0 1 0 .894-1.79l-.445-.222A1.812 1.812 0 0 1 2 26.863v-6.524Z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.274 36.393A2.5 2.5 0 0 0 1 38.883v5.434a2.5 2.5 0 0 0 2.274 2.49l6 .545A2.5 2.5 0 0 0 12 44.862v-6.524a2.5 2.5 0 0 0-2.726-2.49l-6 .545Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M2 38.339c0-.687.388-1.315 1.002-1.622l.445-.222a1 1 0 1 0-.894-1.79l-.446.224A3.813 3.813 0 0 0 0 38.338v6.523c0 1.444.816 2.764 2.107 3.41l.446.223a1 1 0 1 0 .894-1.79l-.445-.222A1.812 1.812 0 0 1 2 44.863v-6.524Z",
  clipRule: "evenodd"
})));
SvgRectangle73BError.viewBox = '0 0 48 69';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle73BError);
export default ForwardRef;